module.exports = __webpack_public_path__ + "img/step58_a_virtual_agent.ce4ca5a5.png";